
define('template!editPimPrintVariationsTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pim-print-filters">\n    <input type="text" class="pim-print-filter js-code-filter" value="' +
__e( codeFilter ) +
'"\n           placeholder="' +
__e( _.i18n('pim.print.filterCode', null, 'Variation code') ) +
'">\n    ';
 _.each(steps, function (step, index) { ;
__p += '\n    <select class="pim-print-filter js-step-filter" data-step="' +
((__t = ( index )) == null ? '' : __t) +
'" title="' +
__e( step.name ) +
'">\n        <option value="">' +
__e( step.name ) +
': ' +
__e( _.i18n('common.all', null, 'All') ) +
'</option>\n        ';
 _.each(step.values, function (value) { ;
__p += '\n        <option value="' +
__e( value.pimId ) +
'" ' +
((__t = ( filters[index] === value.pimId ? 'selected' : '' )) == null ? '' : __t) +
'>' +
__e( value.name ) +
'</option>\n        ';
 }) ;
__p += '\n    </select>\n    ';
 }) ;
__p += '\n</div>\n\n<div class="pim-print-table-wrapper">\n    <table class="pim-print-table">\n        <thead>\n        <tr>\n            <th>' +
__e( _.i18n('common.code', null, 'Code') ) +
'</th>\n            ';
 _.each(steps, function (step) { ;
__p += '\n            <th>' +
__e( step.name ) +
'</th>\n            ';
 }) ;
__p += '\n            <th>' +
__e( _.i18n('pim.print.template', null, 'Template') ) +
'</th>\n        </tr>\n        </thead>\n        <tbody>\n        ';
 _.each(rows, function (row) { ;
__p += '\n        <tr>\n            <td class="pim-print-code">' +
__e( row.code ) +
'</td>\n            ';
 _.each(row.cells, function (cell) { ;
__p += '\n            <td>' +
__e( cell ? cell.name : '—' ) +
'</td>\n            ';
 }) ;
__p += '\n            <td>\n                ';
 if (row.templateUrl) { ;
__p += '\n                <a href="' +
__e( row.templateUrl ) +
'" target="_blank" rel="noopener noreferrer">PDF</a>\n                ';
 } else { ;
__p += '\n                <span class="pim-print-missing" title="' +
__e( _.i18n('pim.print.noTemplate', null, 'No neutral template from the supplier yet') ) +
'">—</span>\n                ';
 } ;
__p += '\n            </td>\n        </tr>\n        ';
 }) ;
__p += '\n        ';
 if (!rows.length) { ;
__p += '\n        <tr>\n            <td class="pim-print-empty" colspan="' +
((__t = ( steps.length + 2 )) == null ? '' : __t) +
'">' +
__e( _.i18n('pim.print.noVariation', null, 'No combination matches these filters') ) +
'</td>\n        </tr>\n        ';
 } ;
__p += '\n        </tbody>\n    </table>\n</div>\n\n<div class="pim-print-pager">\n    <span>' +
__e( count ) +
' / ' +
__e( total ) +
' ' +
__e( _.i18n('pim.print.combinations', null, 'combinations') ) +
'</span>\n    <button class="btn-action js-page-prev" ' +
((__t = ( page <= 1 ? 'disabled' : '' )) == null ? '' : __t) +
'>&lsaquo;</button>\n    <span>' +
__e( page ) +
' / ' +
__e( pages ) +
'</span>\n    <button class="btn-action js-page-next" ' +
((__t = ( page >= pages ? 'disabled' : '' )) == null ? '' : __t) +
'>&rsaquo;</button>\n</div>\n';

}
return __p
};});

